import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ButtonCopyCode = ({ onClick }) => {
  return (
    <StyledButton onClick={onClick}>
      <i className="bx bx-copy" style={{ fontSize: '1.5rem', color: 'white' }} />
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4em;
  padding: 0 0;
  background: #596fde;
  border: none;

  &:hover {
    background: #4758a1 !important;
  }
`;

ButtonCopyCode.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ButtonCopyCode;
